import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeIndex from '../views/HomeIndex.vue'

Vue.use(VueRouter)

/*解决点击当前路由报错的问题*/
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeIndex
  }, {
    path: '/tools',
    name: 'Tools',
    component: () => import('../views/tools/ToolsIndex.vue')
  }, {
    path: '/article',
    name: 'Article',
    component: () => import('../views/article/ArticleIndex.vue'),
    redirect:'/article/content', //重定向，自动跳转到默认子首页
    children:[
      { path:'edit', name:"文章编辑", component:() => import('../views/article/components/ArticleEdit.vue')},
      { path:'content', name:"目录清单", component:() => import('../views/article/components/ArticleContent.vue')},
      { path:'markdown', name:"文章显示", component:() => import('../views/article/components/ArticleMarkdown.vue')}
    ]
  }, {
    path: '/case',
    name: 'Case',
    component: () => import('../views/case/CaseIndex.vue')
  },  {
    path: '/customize',
    name: 'Customize',
    component: () => import('../views/customize/CustomizeIndex.vue'),
    redirect:'/customize/introduction', //重定向，自动跳转到默认子首页
    children:[ // group = Introduction/Basic/Data/Form/Dialog/Navigation/others
      { path:'introduction', group:'Introduction',name:"说明", component:() => import('../views/customize/components/Introduction.vue')},
      { path:'table', group:'Basic',name:"表格- Form", component:() => import('../views/customize/components/TanTable.vue')},
      { path:'input', group:'Basic',name:"输入框- Input", component:() => import('../views/customize/components/TanInput.vue')},
      { path:'dialog', group:'Basic',name:"弹窗- Dialog", component:() => import('../views/customize/components/TanDialog.vue')}
    ]
  }, {
    path: '/mark',
    name: 'Mark',
    component: () => import('../views/mark/MarkIndex.vue')
  }, {
    path: '/about',
    name: 'About',
    component: () => import('../views/about/AboutIndex.vue')
  }, {
    path: '/count',
    name: 'Count',
    component: () => import('../views/Count/CountIndex.vue')
  }, {
    path: '/404',
    name: '404',
    component: () => import('../views/error/404.vue')
  }, {
    path: '/401',
    name: '401',
    component: () => import('../views/error/401.vue')
  },{ //其他任意路由的导航
    path:'*',
    redirect:'/404'
  }

]

const scrollBehavior = function (to, from, savedPosition) { //无法滚动,未使用和生效
  if(to.hash){
    return {
      selector: to.hash
    }
  }else {
    return savedPosition || { x: 0, y: 0 }
  }
}


const router = new VueRouter({
  routes,
  mode: 'history',
  base: '/',
  linkActiveClass:'activeClass' //激活的路由自动套用 activeClass样式
  //scrollBehavior 页面无法滚动
})

export default router
